import { ValidationError as YupValidationError } from 'yup'

export interface ValidationError extends Omit<YupValidationError, 'path'> {
  path: string
}
